export const commMsg = {

  "SAVED.SUCCESSFULLY": "Saved successfully",
  "UPLOADED.SUCCESSFULLY": "Uploaded successfully",
  "UPLOAD.CANCELLED": "Upload cancelled",
  "DELETED.SUCCESSFULLY": "Deleted successfully",
  "Network.Error": 'Network error. Unable to access server',


  "REQUIRED.FIELD": "This is required field",
  "INVALID.INTEGER.FIELD": "Invalid integer value",

  "FIELD.REQUIRED": "{0} is required",
  "MONTHLY.PRICE.LT.ONE": "Monthly price should be greater than one",
  "FIELD.VALUE.ALREADY.USED": "{0} is already used",
  "FIELD.VALUE.LIMIT.EXCEEDS": "{0} should be less than {1}",
  "URLSUFFIX.ISNOT.ALPHANUMERIC" : "Customized url should have only alphabet or number",
  "FIELD.VALUE.IMMUTABLE" : "{0} can't change",
  "EMAIL.NOT.FOUND": "Email not found",
  "RESEND.OTP.AFTER.1MIN": "Resend otp after one minute",
  "RESEND.OTP.MAX.TRIES.REACHED.TRY.AFTER.30MIN": "Please wait for 30 minutes"
}
